








import Vue from "vue";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Overlay
  },
  props: {
    iconName: {
      type: String,
      default: "Spin"
    },
    customStyle: {
      type: String,
      default: ""
    }
  }
});
